/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const tlMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': 'I-update',
  'dashboards.save': 'I-save',
  'dashboards.saveSchedule': 'I-save ang iskedyul',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Mga Ticket',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'Bilang ng Ticket',
  'dashboards.commonticketsubmission': 'Karaniwang Pagsusumite ng Ticket',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'Bansa',
  'dashboards.webVisitors': 'Mga Bisita sa Web',
  'dashboards.avatarClicks': 'Mga Pag-click sa Avatar',
  'dashboards.wordCloud': 'Ulap ng Salita',
  'dashboards.topic': 'Mga Paksa',
  'dashboards.name': 'Pangalan',
  'dashboards.button': 'Buton',
  'dashboards.visits': 'Pagbisita',
  'dashboards.checkAvailability': 'Suriin ang Availability o Presyo',
  'dashboards.details': 'Mga detalye',
  'dashboards.roomsAvailability': 'Mga Silid at Availability',
  'dashboards.startChat': 'Simulan ang Chat',
  'dashboards.restaurantsBars': 'Mga Restawran at Bar',
  'dashboards.groupBooking': 'Panggrupong Booking',
  'dashboards.promotions': 'Mga Promosyon',
  'dashboards.weedingevents': 'Kasalan & Mga Kaganapan',
  'dashboards.lostsomething': 'Nawala ang Isang Bagay',
  'dashboards.producttext': 'Teksto ng Produkto',
  'dashboards.bookingroomnew': 'Mag-book ng Bagong Silid',
  'dashboards.email': 'Email',
  'dashboards.phone': 'Telepono',
  'dashboards.zipcode': 'Zip Code',
  'dashboards.marketingconsent': 'Pahintulot sa Marketing',
  'dashboards.additionalinfo': 'Karagdagang Impormasyon',
  'dashboards.viewallcontacts': 'Tingnan Lahat ng Contacts',
  'dashboards.current': 'Kasalukuyan',
  'dashboards.last7days': 'Huling 7 Araw',
  'dashboards.last30days': 'Huling 30 Araw',
  'dashboards.thisweek': 'Ngayong Linggo',
  'dashboards.thismonth': 'Ngayong Buwan',
  'dashboards.previousmonth': 'Nakaraang Buwan',
  'dashboards.yeartodate': 'Taon Hanggang Ngayon',
  'dashboards.lastyear': 'Noong Nakaraang Taon',
  'dashboards.all': 'Lahat',
  'dashboards.standardOccupancy': 'Karaniwang Kakayahan',
  'dashboards.max-occupancy': 'Pinakamataas na bilang ng tao',
  'dashboards.numberOfThisType': 'Bilang ng Uri na Ito',
  'dashboards.displayOrder': 'Kaayusan ng Pagpapakita',
  'dashboards.provider': 'Tagapagbigay',
  'dashboards.edit': 'I-edit',
  'dashboards.delete': 'Tanggalin',
  'dashboards.addImages': 'Magdagdag ng Mga Larawan',
  'dashboards.location_ip': 'Halagáng lokasyon batay sa IP address',
  'dashboards.near': 'Malapit',
  'dashboards.referral': 'User na na‑refer sa iyong pahina ng website na ito',
  'dashboards.calling_party': 'Nag‑call na User',
  'dashboards.called_party': 'Tinawag na User',
  'dashboards.lastdial': 'Huling Tawag',
  'dashboards.imagelink': 'Link ng Imahe',
  'dashboards.browsegallery': 'Mag‑browse ng Gallery',
  'dashboards.changelog': 'Talaan ng Pagbabago',
  'dashboards.externalresources': 'Panlabas na Resources',
  'dashboards.webpage': 'Pahina ng Web',
  'dashboards.web-pages': 'Mga Pahina ng Web',
  'dashboards.published': 'Na-publish',
  'dashboards.adddocument': 'Magdagdag ng Dokumento',
  'dashboards.ready-to-publish': 'Handa nang Ilathala',
  'dashboards.draft': 'Draft',
  'dashboards.order-by': 'Ayon sa pagkakasunod-sunod',
  'dashboards.add-faq': 'Magdagdag ng FAQ',
  'dashboards.collections': 'Koleksyon',
  'dashboards.items': 'Mga Item',
  'dashboards.rooms-availability': 'Mga Kuwarto at Pagkakaroon',
  'dashboards.events-wedding-venues': 'Mga Kaganapan at Lugar ng Kasalan',
  'dashboards.long-stay-enquiry': 'Pagtatanong para sa Mahabang Pananatili',
  'dashboards.reservation-confirmation-request':
    'Kahilingan ng Kumpirmasyon sa Reserbasyon',
  'dashboards.modify-cancel-booking': 'Baguhin o Kanselahin ang Booking',
  'dashboards.left-something-behind': 'May Naiwan',
  'dashboards.invoice-copy': 'Kopya ng Resibo / Invoice',
  'dashboards.sync': 'I-sync',
  'dashboards.syncNow': 'I-sync ngayon',
  'dashboards.add-web-page': 'Mag‑dagdag ng Web Page',
  'dashboards.sprint-title':
    'Kilalanin ang Sprint, ang aming breakthrough automation para sanayin ang AI Model nang 10x na mas mabilis.',
  'dashboards.sprint-description':
    'Nakikipagtulungan ang Sprint sa iyo—upang palayain ang pagkamalikhain, mapalakas ang produktibidad, at mabawasan nang malaki ang oras ng pagsasanay sa Digital Assistant.',
  'dashboards.sprint-feature':
    'Ang tampok na Sprint ay idinisenyo upang i-sync ang kaalaman mula sa mga panlabas na pinagkukunan, na mahalaga para sa parehong unang setup at patuloy na pag-update ng data. Kapag isinagawa sa isang aktibong sistema, binabago ng Sprint ang Knowledge Hub batay sa iyong na-configure na mga panlabas na pinagkukunan, na maaaring direktang makaapekto sa mga AI-generated na kilos at tugon. Para sa tulong sa setup ng Sprint, mangyaring makipag-ugnayan sa aming support team.',
  'dashboards.change-password': 'Palitan ang Password',
  'dashboards.sign-out': 'Mag-sign Out',
  'dashboards.privacy-policy': 'Patakaran sa Privacy',
  'dashboards.help-center': 'Help Center',
  'dashboards.switch-account': 'Palitan ang Account',
  'dashboards.business-settings': 'Mga Setting ng Negosyo',
  'dashboards.notifications-allowed': 'Mga Abiso Pinapayagan',
  'dashboards.dark-theme': 'Madilim na Tema',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Invoice & Mga Bayad',
  'dashboards.upgrade-plan': 'I-upgrade ang Plano',
  'dashboards.add-room': 'Magdagdag ng Silid',
  'dashboards.room-type': 'Uri ng Silid',
  'dashboards.room-name': 'Pangalan ng Silid',
  'dashboards.how-many-guests': 'Kabuuang bilang ng mga bisita bawat kuwarto',
  'dashboards.number-of-rooms-this-type': 'Bilang ng mga kuwarto',
  'dashboards.number-of-bedrooms': 'Bilang ng mga silid-tulugan',
  'dashboards.number-of-livingrooms': 'Bilang ng mga sala',
  'dashboards.minimum-adults': 'Pinakamababang Adulto',
  'dashboards.maximum-adults': 'Pinakamataas na Adulto',
  'dashboards.maximum-children': 'Pinakamataas na Bata',
  'dashboards.maximum-infants': 'Pinakamataas na Sanggol',
  'dashboards.extra-beds-allowed': 'Payagan ang dagdag na kama',
  'dashboards.booking-engine-code': 'Booking Engine Code',
  'dashboards.room-size': 'Sukat ng Silid',
  'dashboards.balcony-area': 'Laki ng Balkonahe',
  'dashboards.unit': 'Yunit',
  'dashboard.whatsapp_message': 'I-type ang iyong mensahe dito...',
  'dashboard.whatsapp_reply_window':
    'Mayroon kang 24-oras na window upang tumugon sa mensahe ng customer sa WhatsApp Business mula sa oras ng huling mensahe ng customer. Kung tumugon ka sa loob ng 24-oras na window ng customer care, maaari kang magpadala ng anumang uri ng mensahe. Kapag nagsara na ang 24-oras na window, maaari ka lamang magpadala ng mga mensahe gamit ang mga paunang naaprubahang Message Template, na muling magsisimula ng 24-oras na window kapag tumugon ang customer.',
  'dashboards.square-meters': 'Metro kuwadrado',
  'dashboard.pick_quick_reply':
    'Pumili ng mabilis na sagot o i-type ang iyong mensahe',
  'dashboard.hang_in_there':
    'Sandali lang habang sinusubukan ka naming ikonekta!',
  'dashboard.outbound_msg': 'Kailan ipapadala ang palabas na mensahe',
  'dashboard.message_sent': 'Matagumpay na naipadala ang iyong mensahe!',
  'dashboard.failed_msg': 'Hindi naipadala ang mensahe',
  'dashboard.new_chat_message': 'Bagong mensahe sa chat',
  'dashboard.user_msg':
    'May mensahe mula sa user sa loob ng huling 24 oras. Maaari kang sumagot gamit ang anumang mensahe. Gusto mo pa bang ipadala ang template na mensaheng ito o sumagot gamit ang ibang mensahe?',
  'dashboard.us_number':
    'Hindi ipinapadala ang mga WhatsApp Business message sa mga numero sa U.S. dahil pansamantalang itinigil ng Meta ang lahat ng marketing message sa mga numero sa U.S. noong Abril 1, 2025.',
  'dashboard.error_msg': 'Pakikumpleto nang tama ang lahat ng placeholder.',

  'web-widget.title': 'Mga Menu ng Web Widget para sa Chatbot ng Website',

  /*Home page*/
  'dashboards.quickstartwithai': 'Mabilis na Pagsisimula gamit ang AI',
  'dashboards.fastestpathtoautomation':
    'Nasa pinakamabilis na landas ka patungo sa awtomasyon gamit ang mga AI tools',
  'dashboards.insightsthatempower': 'Mga Insight na Nagbibigay Lakas',
  'dashboards.trainchatbot': 'Sanayin ang Chatbot',
  'dashboards.automatewithforms': 'Awtomasyon gamit ang Mga Form',
  'dashboards.inroomdigitalcompendium': 'Digital na Kompendyum sa Silid',
  'dashboards.support': 'Suporta',
  'dashboards.helpcenter': 'Help Center',
  'dashboards.searchfaqintegrations':
    'Maghanap ng artikulo tungkol sa karaniwang FAQ, integrations at iba pa.',
  'dashboards.asklivechat': 'Magtanong sa aming team sa Live Chat',
  'dashboards.inroomqrcode':
    'In‑room QR code upang makita ang impormasyon tungkol sa property at lokasyon',
  'dashboards.customizewebwidget':
    'I-customize at idagdag ang Web Widget sa iyong website na may naka‑integrate na AI Chatbot',
  'dashboards.createcustomforms':
    'Gumawa ng custom forms at makakuha ng notifications kapag nagsubmit ang guest',
  'dashboards.trainchatbotproperty':
    'Sanayin ang Chatbot gamit ang impormasyon tungkol sa iyong property tulad ng check‑in time, activities, at iba pa',
  'dashboards.chatbotinsights':
    'Tingnan kung paano nakikipag‑ugnayan ang Chatbot mo sa mga guest at makakuha ng insights sa stats tulad ng website visitors, mga madalas na tanong, at marami pa.',
  'dashboards.addaichatbottoyourwebsite':
    'Idagdag ang AI Chatbot sa iyong Website',

  /* Email Stats */
  'dashboards.thread-summary-title': 'Mga Buod ng Thread',
  'dashboards.thread-summary-subtitle': 'Mga buod ng email na ginawa ng AI',
  'dashboards.ai-replies-title': 'Mga Tugon ng AI',
  'dashboards.ai-replies-subtitle': 'Mga tugon na ginawa ng AI',
  'dashboards.total-thread-summary-title':
    'Kabuuang Buod ng Mga Thread na Nalikha',
  'dashboards.total-ai-replies-title': 'Kabuuang Tugon ng AI na Nalikha',
  'dashboards.total-draft-copied': 'Draft na Kinopya ng Mga Gumagamit',
  'dashboards.urgency': 'Kabagalan',
  'dashboards.sentiment': 'Damdam',
  'dashboards.common-email-reasons': 'Karaniwang Dahilan ng Email',
  'dashboards.topics-in-emails': 'Mga Paksa sa mga Email',
  'dashboards.email-assistant-usage': 'Paggamit ng AI Email Assistant',
  'dashboards.usage-by-email-address': 'Paggamit ayon sa Address ng Email',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Mga mensahe',
  'chat.contacts': 'Mga contact',
  'chat.saysomething': 'Magsalita ka..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  'property-info.allcustomers': 'Lahat ng mga customer',
  'property-info.external-sources': 'Panlabas na Pinagmumulan',
  'property-info.faq': 'Mga Madalas Itanong',
  'property-info.documents': 'Mga Dokumento',
  'property-info.publish-ai': 'I-publish gamit ang AI',
  'property-info.pre-built-templates': 'Mga Paunang Ginawang Template',
  'property-info.room-types': 'Mga Uri ng Kuwarto',
  'property-info.about-property': 'Tungkol sa Pag-aari',
  'property-info.about-properties': 'Tungkol sa Properties',
  'property-info.facilities-services': 'Mga Pasilidad at Serbisyo',
  'property-info.property-facilities': 'Mga Pasilidad sa Pag-aari',
  'property-info.room-amenities': 'Mga Kagamitan sa Silid',
  'property-info.property-contact': 'Pag-ugnay sa Ari-arian',
  'property-info.property-activities': 'Mga Aktibidad sa Pag-aari',
  'property-info.property-location': 'Lokasyon ng Ari-arian',
  'property-info.about-rooms': 'Tungkol sa Mga Kwarto',
  'property-info.about-sites': 'Tungkol sa Mga Site',
  'property-info.special-emergencies': 'Mga emerhensiya',
  'property-info.gallery': 'Gallery',
  'property-info.policies': 'Mga Patakaran',
  'property-info.nearby': 'Malapit',
  'property-info.transport': 'Transportasyon',
  'property-info.location': 'Lokasyon',
  'property-info.about-rhproperty': 'Tungkol sa Tahanan sa Pagreretiro',
  'property-info.related-topics': 'Mga Kaugnay na Paksa',
  'property-info.assistant-options': 'Mga Pagpipilian sa Assistant',
  'property-info.restaurant-assistant-information': 'Impormasyon sa Restaurant',
  'property-info.restaurant-assistant-options': 'Pambungad na mensahe',
  'property-info.channel-messages': 'Mga Mensahe sa Channel',
  'property-info.icon.gallery': 'Icon Gallery',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Impormasyon sa Tahanan',
  'property-info.loction': 'Mga lokasyon',
  'property-info.rooms-and-images': 'Mga Kwarto at Larawan',
  'property-info.trainig-data': 'Data ng Pagsasanay',
  'property-info.flows': 'dumadaloy',
  'property-info.add-your-own': 'Idagdag ang Iyong Sariling',
  'property-info-utility-miscellaneous': 'Miscellaneous',
  'property-info-utility-payment': 'Mga pagbabayad',
  'property-info-utility-broadband': 'Broadband',
  'property-info-utility-emergency': 'Emergency',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'Gumagalaw',
  'property-info.publishMonitor': 'I-publish at I-monitor',
  'property-info.webWidget': 'Widget sa Web',
  'property-info.media': 'Midya',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Mga Plano ng Rate',
  'rate-promo.rate-plan-addons': 'Mga add-on',
  'rate-promo.rate-plan-promos': 'Mga Promos',

  'title.property-information': 'Impormasyon sa Pag-aari',

  'property.message': 'Mensahe',
  'property.example': 'Halimbawa',
  'property.link': 'Mga link',
  'property.image-carousel': 'Image Carousel',
  'property.Title': 'Pamagat',
  'property.SubTitle': 'Pamagat ng Sub',

  'property.add-invoke-api': 'Tawagan si Api',
  'property.add-message-button': 'Magdagdag ng Mga Mensahe',
  'property.add-img-button': 'Magdagdag ng Mga Larawan',
  'property.add-link-button': 'Magdagdag ng Link',
  'property.add-herocard-button': 'Magdagdag ng Hero Card',
  'property.add-api-button': 'Magdagdag ng Mga Pindutan',

  'menu.settings': 'Mga Setting',
  'menu.workflows': 'Daloy ng Trabaho',
  'menu.product_services': 'Mga Produkto at Serbisyo',
  'menu.product_recommander': 'Tagapagrekomenda ng Produkto',
  'menu.digital_guide_book': 'Digital Na Gabay',
  'menu.welcome_message': 'Mensahe ng Pagbati',
  'menu.about-property': 'Tungkol sa Ari-arian',
  'menu.property-facilities': 'Mga Pasilidad ng Ari-arian',
  'menu.room-amenities': 'Mga Amenity ng Silid',
  'menu.property-contact': 'Kontak ng Ari-arian',
  'menu.about-rooms': 'Mga Silid',
  'menu.special-emergencies': 'Mga Emergency',
  'menu.show-filter': 'Mga Filter',
  'menu.new': 'Bago',
  'menu.channel': 'Mga Channel',
  'menu.application': 'Mga Aplikasyon',
  'menu.content-manager': 'Tagapamahala ng Nilalaman',
  'menu.events-calendar': 'Kalendaryo ng Mga Kaganapan',
  'menu.appearance-settings': 'Hitsura at Mga Setting',

  'dashboards.send': 'Ipadala',
  'dashboards.hello': 'Kamusta',
  'dashboards.notificationsAllowed': 'Alam na Pahintulutan ang Mga Abiso',
  'dashboards.allowNotifications': 'Pahintulutan ang Mga Abiso',
  'dashboards.views': 'Mga Pagtingin',
  'dashboards.bookingURL': 'URL ng Booking',
  'dashboards.searchTags': 'Mga Tag ng Paghahanap',
  'dashboards.searchCategoryTags': 'Mga Tag ng Kategorya ng Paghahanap',
  'dashboards.bedroom': 'Silid-tulugan',
  'dashboards.addBedroom': 'Magdagdag ng Silid-tulugan',
  'dashboards.frequency': 'Dalasan',
  'dashboards.includeSubpages': 'Isama ang Mga Sub‑Pahina',
  'dashboards.enableFaqs': 'Payagan ang mga FAQ',
  'dashboards.faqsDescription':
    'Ang pagpapagana ng FAQs ay nagpapahintulot sa iyo na mag-input ng mga tanong habang kinukuha ng sistema ang mga kaukulang sagot mula sa nilalaman ng Web Page upang lumikha ng kumpletong FAQs',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Tanggalin ang Dokumento',
  'dashboards.confirmDelete': 'Sigurado ka bang gusto mong tanggalin?',
  'dashboards.addItem': 'Magdagdag ng Item',
  'dashboards.addFirstWebPage': 'Idagdag ang Iyong Unang Web Page',

  'dashboards.popular-compendium': 'Mga Sikat na Item sa Compendium Menu',
  'dashboards.wordcloudofcompendium':
    'Ulap ng mga Salita ng Compendium Menu Item',
  'dashboards.wordcloudonthings':
    'Ulap ng mga Salita tungkol sa mga Tanong ng Mga Bisita ng Website at Mga Item ng Menu',
  'dashboards.common-asked': 'Mga Karaniwang Tanong',
  'dashboards.website-visitor-asking':
    'Mga Bagay na Tinatanong ng Mga Bumibisita sa Website',
  'dashboards.visit-country': 'Pagbisita sa Website ng Bansa',
  'dashboards.visit-traffic': 'Country Of The Website Traffic',
  'dashboards.rooms-product': 'Mga Kwarto at Produkto',
  'dashboards.popular-room-product': 'Mga sikat na kwarto at produkto',

  'dashboards.messenger-stats': 'Mga Sikat na Item sa Menu',
  'dashboards.messenger-stats-topic-view': 'Stats sa Mga View ng Item sa Menu',
  'dashboards.messenger-stats-visits': 'Mga View ng Item sa Menu',
  'dashboards.opening-menu-items':
    'Bilang ng mga Bisita sa Website na nagbubukas ng Mga Item sa Menu',

  'dashboards.number-totalavatarclick': 'Kabuuang Mga Pag-click sa Avatar',
  'dashboards.subscribe-to-reports': 'Mag-subscribe sa mga ulat',
  'dashboards.clicks': 'Mga pag-click',
  'dashboards.leads': 'Nangunguna',
  'dashboards.hours': 'Oras',
  'dashboards.connect': 'Ikonekta',
  'dashboards.minutes': 'Mga minuto',
  'dashboards.tickets-by-category': 'Mga tiket ayon sa Kategorya',
  'dashboards.download': 'I-download',
  'dashboards.ai-chatbot': 'AI Chatbot',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Paggamit ng Digital Compendium',
  'dashboards.compendium-unique-visits': 'Mga pag-scan/pag-click ng QR code',
  'dashboards.compendium-opening-menu-items':
    'Bilang ng mga item sa menu na tiningnan',
  'dashboards.compendium-total-digital-clicks':
    'Kabuuang Mga Pagtingin sa Item sa Menu',
  'dashboards.compendium-total-qr-code':
    'Kabuuang Mga Pag-scan/Pag-click sa QR code',
  'dashboards.compendium-avg-menu-items': 'Avg Menu Item Views Bawat Pag-scan',
  'dashboards.top-clicked-urls': 'Pinaka-na-click na mga URL',
  'dashboards.top-clicked-urls-description': 'Pagsusuri ng pag-click ng URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'Ang dokumentong ito ay ginawa mula sa mga panlabas na source. Kung ayaw mong ito ay muling malikha, siguraduhing alisin din ang kaugnay na iskedyul ng sync.',
  'dashboards.deleteAndGoToExternalSources':
    'Tanggalin at pumunta sa External Sources',
  'property.delete': 'Tanggalin',
  'menu.userroles': 'Mga Gumagamit at Tungkulin',
  'menu.members': 'Mga miyembro',
  'menu.guest-pass': 'Pahintulot para sa Panauhin',
  'menu.ratebookings': 'Mga Rate at Pag-book',
  'dashboards.engagement-time':
    'Oras ng Pakikipag-ugnayan sa Digital Assistant',
  'dashboards.conversations-minutes':
    'Kabuuang Minuto at Magdamag (7pm hanggang 7am) Mga Minuto ng Pag-uusap',
  'dashboards.conversations': 'Mga pag-uusap',
  'dashboards.total-messages': 'Kabuuang Mensahe',
  'dashboards.visitor-questions': 'Mga Tanong ng Bisita',
  'dashboards.recent-queries': 'Mga Kamakailang Tanong',
  'dashboards.visitor-saying':
    'Ang sinasabi ng iyong mga bisita sa Digital Assistant',
  'dashboards.contacts-prechatform-leavemessage':
    'Mga Naka-imbak na Contact mula sa Pre Chat Form at Mag-iwan ng Mensahe',
  'menu.dashboards': 'Mga Pananaw',
  'menu.ari': 'Pagkakaroon at Mga Rate',
  'menu.conversations': 'Mga pag-uusap',
  'menu.conversations.unified-inbox': 'Pinag-isang Inbox',
  'menu.conversations.active': 'Mga Aktibong Chat',
  'menu.conversations.archives': 'Mga archive',
  'menu.conversations.missed-responses': 'Mga Hindi Nasagot na Tugon',
  'menu.conversations.ticket': 'Mga tiket',
  'menu.conversations.reply-templates': 'Mga Template ng Tugon',
  'menu.bookings': 'Mga Pagpapareserba at Pag-book',
  'menu.tickets': 'Mga lead at tiket',
  'menu.propinfo': 'Hub ng Kaalaman',
  'menu.rate-promos': 'Mga Rate at Promosyon',
  'menu.finance': 'Pananalapi',
  'menu.integration': 'Kumonekta',
  'menu.admin': 'Admin at Seguridad',
  'menu.favourites': 'Mga paborito',
  'menu.recommender': 'Daloy ng Pag-uusap',
  'menu.assistant-setup': 'Setup ng Assistant',
  'menu.admin-insights': 'Mga Insight ng Admin',
  'menu.super-admin': 'Super Admin',
  'menu.groups': 'Mga grupo',
  'menu.properties': 'Mga Katangian',
  'menu.service-provider': 'Mga Tagabigay ng Serbisyo',
  'menu.spaces': 'Mga puwang',
  'menu.availability': 'Pagkakaroon',
  'menu.help': 'Tulong',
  'menu.myAccounts': 'Tài khoản của tôi',

  'dashboards.space-booking': 'Space Booking',
  'dashboards.gift-voucher': 'Mga Gift Voucher',
  'dashboards.chatbots': 'Mga Chatbot',
  'dashboards.form': 'Mula sa',
  'dashboards.to': 'Upang',
  'dashboards.active-groups': 'Mga Aktibong Grupo',
  'dashboards.active-properties': 'Mga Aktibong Katangian',
  'dashboards.live-properties': 'Mga Live na Property',
  'dashboards.properties-going':
    'Magiging live ang mga property ayon sa hanay ng petsa',
  'dashboards.start-date': 'Petsa ng Pagsisimula',
  'dashboards.end-date': 'Petsa ng Pagtatapos',

  'dashboards.website-visits': 'Mga Pagbisita sa Website',
  'dashboards.unique-visitors': 'Kakaibang Bisita',
  'dashboards.last-week': 'Nakaraang linggo',
  'dashboards.this-week': 'Ngayong linggo',
  'dashboards.this-month': 'Sa buwang ito',
  'dashboards.previous-month': 'Nakaraang Buwan',
  'dashboards.yeartodate': 'Taon hanggang Petsa',
  'dashboards.lastyear': 'Noong nakaraang taon',
  'dashboards.last-7-days': 'Huling 7 Araw',
  'dashboards.last-30-days': 'Huling 30 Araw',
  'dashboards.last-60-days': 'Huling 60 Araw',
  'dashboards.last-90-days': 'Huling 90 Araw',
  'dashboards.conversion-rates': 'Mga Rate ng Conversion',
  'dashboards.digital-assistant-engagement':
    'Pakikipag-ugnayan sa Digital Assistant',
  'dashboards.total-overnight-conversations':
    'Kabuuan at Magdamag (7pm hanggang 7am) Mga Pag-uusap',
  'dashboards.percentage-accuracy': 'Saklaw ng Kaalaman',
  'dashboards.percentage-conversion':
    'Trapiko sa Website sa Conversion ng Chat',
  'dashboards.percentage-avatarclick':
    'Trapiko ng Website sa Mga Pag-click sa Avatar',
  'dashboards.percentage-negativefeedback':
    'Negatibong Feedback bilang isang %edad ng Mga Pag-click sa Avatar',
  'dashboards.percentage-amenties': 'Mga Query sa Amenity',
  'dashboards.percentage-booking': 'Mga Pagtatanong sa Pag-book',
  'dashboards.percentage-webchats': 'Mga Website Chat',
  'dashboards.percentage-facebookchat': 'Mga Chat sa Facebook',
  //'dashboards.number-webchattime': 'Kabuuang Oras ng Pag-chat sa Web',
  'dashboards.number-webchattime': 'Kabuuang Oras ng Pag-uusap',
  'dashboards.number-totalconversation': 'Kabuuang Pag-uusap',
  'dashboards.number-websiteconversation': 'Mga Pag-uusap sa Website',
  'dashboards.number-facebookconversation': 'Mga Pag-uusap sa Facebook',
  'dashboards.number-estimatedtimesaving': 'Tinatayang Pagtitipid sa Oras',
  'dashboards.number-googlemapsconversation': 'Mga Pag-uusap sa Google Maps',
  'dashboards.number-whatsappconversation': 'Mga Pag-uusap sa WhatsApp',
  'dashboards.number-instagramconversation': 'Mga pag-uusap sa Instagram',
  'dashboards.number-agentconversation': 'Mga Pag-uusap sa Ahente',
  'dashboards.number-amenityqueries': 'Mga Amenity Query',
  'dashboards.number-bookingenquiries': 'Mga Tanong sa Pag-book',
  'dashboards.number-groupbookingenquiries': 'Mga Tanong sa Pag-book ng Grupo',
  'dashboards.number-eventenquiries': 'Mga Pagtatanong sa Kaganapan',
  'dashboards.number-longstayenquiries': 'Mga Tanong sa Long Stay',
  'dashboards.number-totaltickets': 'Mga tiket',
  'dashboards.number-returncustomer': 'Bumalik na Customer',
  'dashboards.number-redirects': 'Mga Pag-redirect ng Website',
  'dashboards.number-bookingengineleads': 'Mga Lead sa Booking Engine',
  'dashboards.number-roomnightsreferred': 'Room Nights Referred',
  'dashboards.number-revenuereferred': 'Referred na Kita',
  'menu.bookingsmenu': 'Mga Pagbu-book',
  'menu.guests': 'Impormasyon ng Bisita',
  'menu.whatsnew': 'Anong bago',
  'menu.guest-messaging': 'Mensaheng Panauhin',
  'guest-messaging.settings': 'Mga Setting',
  'guest-messaging.outreach-setup': 'Setup ng Outreach',
  'guest-messaging.reservations': 'Mga Reserva',
  'guest-messaging.insights_logs': 'Insights at mga log',
  'guest-messaging.placeholder':
    'Malapit nang dumating ang Guest Messaging module.',
  'guest-messaging.settings.placeholder':
    'Itakda ang mga guest messaging na kagustuhan.',
  'guest-messaging.outreach.placeholder':
    'I-setup ang outreach campaign at mga template.',
  'guest-messaging.reservations.placeholder':
    'Pamahalaan ang mga mensahe para sa reserva.',
  'guest-messaging.reservation-source': 'Pinagmulan ng Data ng Reserva',
  'guest-messaging.communication-channels': 'Mga Channel ng Komunikasyon',
  'guest-messaging.templates': 'Mga Template',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Profile ng Negosyo',

  'forms.forms-title': 'Form',
  'menu.formbuilder': 'Tagabuo ng form',
  'dashboards.trainAI': 'Sanayin ang AI gamit ang mga dokumento',
  'dashboards.uploadDocuments':
    'Mag-upload ng mga dokumento upang matulungan ang iyong AI na matutunan ang tungkol sa iyong negosyo at tumulong sa mga customer tulad ng ginagawa mo. Maaari kang magdagdag ng mga file na .doc, .pdf, o .txt.',
  'dashboards.welcomeMessage': 'Mensaheng Pang-alaala',
  'dashboards.personalizeGreeting':
    'I-personalize ang paraan ng pagbati sa mga customer upang ipakita ang iyong brand, estilo, at etiketa, tinitiyak na sila’y mararamdaman ang mainit na pagtanggap. I-customize ang mga pagbati para ipakita ang iyong brand at makalikha ng mainit na pagtanggap.',
  'dashboards.addRoomDetails':
    'Magdagdag ng mga detalye tungkol sa bawat isa sa iyong mga silid upang madali nilang matuklasan ang lahat ng kailangan nila upang piliin ang perpektong tugma at gawing mas simple at mabilis ang proseso ng pag-book.',
  'dashboards.trainAIFAQs': 'Sanayin ang AI gamit ang FAQs',
  'dashboards.manualQuestions':
    'May ilang mga tanong na hindi masagot ng mga dokumento o matagpuan sa website. Dito, maaari mong manu-manong idagdag ang mga tanong upang matiyak na palaging may hawak ang mga customer sa impormasyong kailangan nila.',
  'dashboards.publishAI':
    'I-publish ang AI upang ipakita ang pinakabagong mga update',
  'dashboards.retrainAfterChanges':
    'Kapag gumawa ka ng mga pagbabago sa Knowledge Hub o mga form, siguraduhing muling sanayin ang chatbot gamit ang na-update na impormasyon. Ang pag-publish ng iyong AI ay tinitiyak na ang chatbot ay nagbibigay ng pinakamalinaw at pinaka-napapanahong sagot.',
  'dashboards.enhanceKnowledge':
    'Palawakin ang kaalaman ng AI sa pamamagitan ng pagtunton ng mga tanong na hindi nasasagot',
  'dashboards.reviewUnanswered':
    'Kahit kailan na ang AI ay hindi makasagot sa isang tanong o magbigay lamang ng kaunting detalye, makikita mo ang mga tanong na iyon dito. Suriin upang matukoy ang mga puwang sa iyong Knowledge Hub o natatanging tanong ng mga bisita.',
  'dashboards.manageMedia': 'Pamahalaan ang Media',
  'dashboards.mediaGallery':
    'Kahit kailan mong i-upload ang mga larawan gaya ng mga kuwarto, amenidad, logo, o iyong digital avatar, lalabas ang mga ito sa gallery na ito, na nagbibigay sa iyo ng sentrong lugar upang pamahalaan ang mga visual at matiyak na makita ng mga bisita mo kung ano ang nagpapasikat sa iyong negosyo.',
  'dashboards.createForms':
    'Lumikha ng mga form nang madali at makatanggap ng abiso sa bawat pagsusumite.',
  'dashboards.manageForms':
    "Gumawa at pamahalaan ang mga form upang kolektahin ang impormasyon ng customer, itakda ang mga abiso, at i-customize ang mga ito para sa iba't ibang mga wika.",
  'dashboards.personalizeResponse':
    'I-personalize ang istilo ng tugon at paano umuunlad ang pag-uusap',
  'dashboards.controlConversation':
    'Ang advanced na tampok na ito ay nagbibigay sa iyo ng kakayahang hubugin at kontrolin kung paano nagaganap ang mga pag-uusap sa iyong mga customer sa iba’t ibang mga channel.',

  ' menu.virtualfrontdesk': 'Virtual harap mesa',
  'menu.guestservice': 'Serbisyong Panauhin',
  'virtual-front.common-questions': 'Mga Karaniwang Tanong',
  'virtual-front.add-on-upsells': 'Mga Add-on at Upsells',
  'virtual-front.service-order': 'Order sa serbisyo',
  //'virtual-front.guest-service-add-on-upsells': "Mga Serbisyong Pambisita at Add-on",
  'virtual-front.guest-service-add-on-upsells': 'Digital Compendium',
  'virtual-front.outbound': 'Papalabas',
  'virtual-messenger': 'Messenger',

  'missed-response.missed-response-title': 'Napalampas na Pamagat ng Tugon',
  'content.allconversation': 'Lahat ng Usapan',
  'content.active': 'Aktibo',
  'content.tickets': 'Mga Tiket',
  'content.filter': 'Salain',
  'content.createtickets': 'Gumawa ng Tiket',
  'content.conversation': 'Usapan',
  'content.knowledgesearch': 'Paghahanap ng Kaalaman',
  'content.reply': 'Sagot',
  'content.visitorinfo': 'Impormasyon ng Bisita',
  'content.callinfo': 'Impormasyon ng Tawag',
  'content.allinsights': 'Lahat ng Pananaw',
  'content.availabilityrates': 'Pagkakaroon at Presyo',
  'content.callback': 'Tawag Pabalik',
  'content.close': 'Isara',
  'content.sms': 'SMS',
  'content.timestamp': 'Tatak ng Oras',
  'content.topics': 'Mga Paksa',
  'content.callingparty': 'Tumatawag',
  'content.accountdomain': 'Domain ng Account',
  'content.calledparty': 'Tinatawag',
  'content.recording': 'Pagre-record',
  'content.phonesystemoriginationcallid':
    'ID ng Tawag sa Pinagmulan ng Sistema ng Telepono',
  'content.phonesystemterminationcallid':
    'ID ng Tawag sa Pagwawakas ng Sistema ng Telepono',
  'content.uniqueconversationid': 'Natanging ID ng Usapan',
  'content.regenerateinsights': 'Muling Likhain ang Pananaw',
  'content.customersentiment': 'Damdamin ng Customer',
  'content.neutral': 'Neutral',
  'content.customerreportedbroadbandoutage':
    'Iniulat ng customer ang pagkasira ng broadband sa pamamagitan ng pagbibigay ng kanilang customer ID at petsa ng pag-activate ng serbisyo para sa tulong.',
  'content.conversationinsights': 'Pananaw ng Usapan',
  'content.broadbandoutage': 'Pagkawala ng Broadband',
  'content.customeridverification': 'Pagpapatunay ng Customer ID',
  'content.serviceactivationdate': 'Petsa ng Pag-activate ng Serbisyo',
  'content.followups': 'Mga Follow-up',
  'content.actionneeded': 'Kailangang Aksyon',
  'content.uniqueConversationId': 'Natanging Conversation ID',
  'content.uniqueChatId': 'Natanging Chat ID',
  'content.recording&transcript': 'Pagre-record at Transcript',
  'content.chatinsights': 'Mga Insight sa Chat',
  'content.visitedpages': 'Mga Dinaluhang Pahina',
  'content.deviceinfo': 'Impormasyon ng Device',
  'content.chatstartedonthispage': 'Nagsimula ang Chat sa pahinang ito',
  'content.prechatinfo': 'Impormasyon bago ang Chat',
  'content.notes': 'Mga Tala',
  'content.reassign': 'Muling Italaga',
  'content.open': 'Buksan',
  'content.dismiss': 'Isara',
  'content.add_placeholder': 'Magdagdag ng mga halaga ng placeholder',
  'content.mobile_number': 'Numero ng Mobile',
  'content.please_select': 'Mangyaring pumili',
  'content.sendwhatsapp': 'Mag-send ng WhatsApp na mensahe',

  /* Missed Response */
  'feedback.missed-question': 'Hindi nasagot na tanong',
  'feedback.conversation-summary': 'Buod ng pag-uusap',
  'feedback.dates-in-spanish':
    'Ang mga petsa ay kailangang nasa wikang Espanyol',
  'feedback.resolve': 'Lutasin',
  'feedback.ignore': 'Balewalain',

  //integration
  // tl-TL
  'integration.select_properties': 'Piliin ang Mga Ari-arian',
  'integration.select_properties_enabled':
    'Piliin ang mga ari-arian na pinagana sa pamamagitan ng pagsasama na ito',
  'integration.services_addons': 'Piliin ang Mga Serbisyo at Add-on',
  'integration.services_visible':
    'Piliin kung aling mga serbisyo at add-on ang makikita sa pahinang ito',
  'integration.appearance': 'Hitsura',
  'integration.appearance_customize':
    'Piliin ang pangalan ng iyong digital assistant, avatar, at i-set ang iyong mga kulay',
  'integration.booking_calendar': 'Kalendaryo ng Booking',
  'integration.booking_calendar_style':
    'Piliin ang estilo para sa pop‑up ng kalendaryo ng booking',
  'integration.nudges': 'Mga Pahiwatig',
  'integration.nudges_setup':
    'I-setup ang mga proaktibong mensahe para hikayatin ang mga bisita ng website',
  'integration.position': 'Posisyon',
  'integration.position_control':
    'Kontrolin ang posisyon ng chat widget sa iyong website',
  'integration.custom_fonts': 'Pasadyang Mga Font',
  'integration.custom_fonts_upload':
    'I-upload ang anumang pasadyang font na nais mong gamitin para sa pahina',
  'integration.custom_css': 'Pasadyang CSS',
  'integration.custom_css_usage':
    'Gamitin ang CSS para i-customize ang iyong Digital Compendium',
  'integration.location': 'Lokasyon',
  'integration.location_embed': 'Idagdag ang iyong embed location URL',
  'integration.external_links': 'Mga Panlabas na Link',
  'integration.external_links_add': 'Idagdag ang iyong mga link',
  'integration.language': 'Wika',
  'integration.widget_languages': 'Piliin ang mga wika para sa chat widget',
  'integration.chatbot_contact': 'Chatbot ',
  'integration.chatbot_enable': 'I-enable ang iyong digital assistant',
  'integration.chatbot_security': 'Panatilihing Secure ang iyong Messenger',
  'integration.chatbot_trusted_pages':
    'Ilahad ang iyong mga pinagkakatiwalaang pahina para ipakita ang Chatbot',
  'integration.chatbot_publish': 'I-publish ang iyong digital assistant',
  'integration.chatbot_install':
    'Kopyahin ang code snippet upang i-install ang iyong digital assistant',
  'integration.google_analytics': 'Pagsubaybay sa Google Analytics',
  'integration.google_analytics_desc':
    'Subaybayan ang aktibidad ng user, mga session, at mahahalagang aksyon sa Web Widget gamit ang GA4.',
  'integration.enable_ga4': 'I-enable ang Google Analytics',
  'integration.ga4_measurement_id': 'GA4 Measurement ID',
  'integration.ga4_id_example': 'Halimbawa: G-ABCD123456',
  'integration.track_events': 'Subaybayan ang Mga Event',
  'integration.track_events_desc':
    'Piliin kung aling mga aksyon ng user ang ipapadala bilang mga event ng GA4.',
  'integration.avatar_click': 'Pag-click sa Avatar',
  'integration.avatar_click_desc':
    'Subaybayan kapag nag-click ang user sa chat avatar.',
  'integration.nudge_click': 'Pag-click sa Pahiwatig',
  'integration.menu_click': 'Pag-click sa Menu',
  'integration.menu_click_desc':
    'Subaybayan kapag binuksan ng user ang menu ng web widget.',
  'integration.chat_started': 'Nagsimula ang Chat',
  'integration.chat_started_desc':
    'Subaybayan ang unang mensahe ng user isang beses kada session.',
  'integration.event_tag': 'Event Tag',
  'integration.event_prefix': 'Event Prefix',
  'integration.final_tag': 'Final Tag',
  'integration.example_event': 'Halimbawang Event',
  'integration.once_per_session': 'Isang beses lang kada session',
  'integration.saving': 'Nagse-save...',
  'integration.save_ga4_settings': 'I-save ang Mga Setting ng GA4',
};
export default tlMessages;
